// src/pages/projects/Projects.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import ProjectsTable from "../../components/projects/ProjectsTable";

const Projects = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <ProjectsTable />
        </WrapperSection>
    );
};

export default Projects;